const authState = {
  type: '',
  sidResponse: '',
  mobile: '',
  selectedBusiness: {},
  userDetails: {},
  allBusinesses: [],
  profileDetails: {},
};

const authReducer = (state, action = {}) => {
  const { payload, type } = action;
  switch (type) {
    case 'USER_TYPE': {
      return {
        ...state,
        type: payload,
      };
    }
    case 'MOBILE': {
      return {
        ...state,
        mobile: payload,
      };
    }
    case 'SID': {
      return {
        ...state,
        sidResponse: payload,
      };
    }
    case 'SELECTED_BUSINESS': {
      return {
        ...state,
        selectedBusiness: payload,
      };
    }
    case 'USER_DETAILS': {
      return {
        ...state,
        userDetails: payload,
      };
    }
    case 'ALL_BUSINESSES': {
      return {
        ...state,
        allBusinesses: payload,
      };
    }
    case 'RESEND_TIMER': {
      return {
        ...state,
        resendOtp: payload.resendOtp,
      };
    }
    case 'SET_PROFILE_DETAILS': {
      return {
        ...state,
        profileDetails: payload,
      };
    }
    default:
      return state;
  }
};

export { authState, authReducer };
